function varReplacer(additionalData?: Record<string, string>) {
  return (replacingString: string, key: string) => {
    const value = additionalData?.[key[0] === '$' ? key.slice(1) : key]

    return value?.toString() || replacingString
  }
}

export default varReplacer
